import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import {
  FormPanel,
  RemoteTableField,
  ScrollableSource,
  TableFieldCells,
  TableFieldColumn,
  useStaticListSource,
} from '@eas/common-web';
import { Redirect } from '@composite/redirect/redirect';
import { StaticDataContext } from '@components/evidence/static-data-provider/static-data-provider';
import { FormTableCount } from '@components/form/table-field/form-table-count';
import { Loan } from '@models';
import { EvidenceBrowserUrl } from '@enums';

export function LoanField({ source }: { source?: ScrollableSource<Loan> }) {
  const columns = useLoanFieldColumns();
  if (!source) return <>Missing LOAN_SOURCE</>;
  return (
    <FormPanel label="Zápůjčky" summary={<FormTableCount source={source} />}>
      <RemoteTableField
        columns={columns}
        maxRows={7}
        onRowClick={() => {}}
        showRadioCond={() => false}
        showDetailBtnCond={() => false}
        showSpeedDialCond={() => false}
        showToolbar={false}
        source={source}
        disabled
      />
    </FormPanel>
  );
}

function useLoanFieldColumns(): TableFieldColumn<Loan>[] {
  const intl = useIntl();
  const { loanStates } = useContext(StaticDataContext);
  const useLoanStates = () => useStaticListSource(loanStates);

  return [
    {
      datakey: 'id',
      name: '',
      width: 140,
      CellComponent: function Cell(props) {
        return <Redirect url={EvidenceBrowserUrl.LOANS} id={props.value} />;
      },
    },
    {
      datakey: 'loanedOn',
      sortkey: 'loanedOn',
      name: intl.formatMessage({
        id: 'ES__LOANS__COLUMN__Zapůjčeno dne',
        defaultMessage: 'Zapůjčeno dne',
      }),
      width: 140,
      CellComponent: TableFieldCells.DateCell,
    },
    {
      datakey: 'borrower.label',
      sortkey: 'borrower.label',
      name: intl.formatMessage({
        id: 'ES__LOANS__COLUMN__Zapůjčeno komu',
        defaultMessage: 'Zapůjčeno komu',
      }),
      width: 200,
      CellComponent: TableFieldCells.TextCell,
    },
    {
      datakey: 'loanedBy.label',
      sortkey: 'loanedBy.label',
      name: intl.formatMessage({
        id: 'ES__LOANS__COLUMN__Zapůjčil',
        defaultMessage: 'Zapůjčil',
      }),
      width: 200,
      CellComponent: TableFieldCells.TextCell,
    },
    {
      datakey: 'relatedFile.number.value',
      sortkey: 'relatedFile.number.valueSort',
      name: intl.formatMessage({
        id: 'ES__LOANS__COLUMN__Ke spisové značce',
        defaultMessage: 'Ke spisové značce',
      }),
      width: 170,
      CellComponent: TableFieldCells.TextCell,
    },
    {
      datakey: 'state',
      sortkey: 'state.name',
      name: intl.formatMessage({
        id: 'ES__LOANS__COLUMN__Stav',
        defaultMessage: 'Stav',
      }),
      width: 140,
      CellComponent: TableFieldCells.useSelectCellFactory(useLoanStates),
    },
    {
      datakey: 'returnedOn',
      sortkey: 'returnedOn',
      name: intl.formatMessage({
        id: 'ES__LOANS__COLUMN__Vráceno dne',
        defaultMessage: 'Vráceno dne',
      }),
      width: 140,
      CellComponent: TableFieldCells.DateCell,
    },
  ];
}
